export default [
  {
    'id': 1,
    'hamperId': 'LS01-001',
    'dynamic': 'Grandma, Mum, Boy 4, Girl 2',
    'requirements': '',
    'unit': 4
  },
  {
    'id': 2,
    'hamperId': 'LS01-002',
    'dynamic': 'Mum, Dad, Boy 6, Boy 5, Boy 4, Girl 1',
    'requirements': 'No Dairy, Can\'t have nuts',
    'unit': 6
  },
  {
    'id': 3,
    'hamperId': 'LS01-003',
    'dynamic': 'Dad, Girl 1, Girl 1',
    'requirements': '',
    'unit': 3
  },
  {
    'id': 4,
    'hamperId': 'LS01-004',
    'dynamic': 'Dad, Boy 3',
    'requirements': '',
    'unit': 2
  },
  {
    'id': 5,
    'hamperId': 'LS01-005',
    'dynamic': 'Mum, Girl 4',
    'requirements': '',
    'unit': 2
  }
]
